import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ARService } from '../../ar.service';
import { ArCreateTransactionComponent } from '../ar-create-transaction/ar-create-transaction.component';
import { Globals } from '../../../../globals';
import { ToothPickerComponent } from '../../../tdo-shared/tooth-picker/tooth-picker.component';
import { DataPatientCaseModel } from '../../../../models/accountsReceivable/data-patient-case.model';
import { DataARTransactionItemModel } from '../../../../models/accountsReceivable/data-ar-transaction-item.model';
import { DataPatientCaseWorkItemModel } from '../../../../models/accountsReceivable/data-patient-case-work-item.model';
import { FeeScheduleDataModel } from '../../../../models/fee-schedule/fee-schedule-data.model';
import { FeeScheduleItemFeeDataModel } from '../../../../models/fee-schedule/fee-schedule-item-fee-data.model';
import { DataARClaimModel } from '../../../../models/accountsReceivable/data-ar-claim.model';
import { PatientInsuranceCoverageARDataModel } from '../../../../models/accountsReceivable/patient-insurance-coverage-ar-data.model';
import { PatientInsuranceListViewDataModel } from '../../../insurance/models/patient-insurance-list-view-data-view.model';
import { FeeScheduleDoctorDataARModel } from '../../../../models/accountsReceivable/fee-schedule-doctor-data-ar.model';
import { PostTransactionItemModel } from '../../../../models/accountsReceivable/post-transaction-item.model';
import { DoctorByTDOCIDModel } from '../../models/doctor-by-tdocid.model';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { SalutationEnum } from '../../../../models/enum/salutation.enum';
import { ClaimWizardComponent } from '../../claims/claim-wizard/claim-wizard.component';
import { ClaimTypeEnum } from '../../../../models/enum/claim-type.enum';
import { CfgARFeeDiscountModel } from '../../../../models/accountsReceivable/cfg-ar-fee-discount.model';
import { FeeVariablesModel } from '../../models/ar-fee-variables.model';
import { EnumFeeDiscountCalcTypeEnum } from '../../../../models/enum/enum-fee-discount-calc-type.enum';
import { Constants, LOCID } from '../../../../constants';
import { LOCIDModel } from '../../models/select-tdocid-locid.model';
import { DataPatientCaseWorkItemToothModel } from '../../../../models/teeth/data-patient-case-work-item-tooth.model';
import { ToothPickerConfigModel } from '../../../tdo-shared/tooth-picker/tooth-picker-config.model';
import { ArFeeCalculationErrorComponent } from '../ar-fee-calculation-error/ar-fee-calculation-error.component';
import { ARFeeErrorItem, ARFeeErrors } from '../../models/ar-fee-error-items';
import { NotesService } from '../../../../services/notes.service';
import { TdoNoteQueryModel } from '../../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import { CaseItemSelectComponent } from '../../../case-forms/case-item-select/case-item-select.component';
import { ToothSurfacePickerComponent } from '../tooth-surface-picker/tooth-surface-picker.component';
import { DialogService } from '../../../../services/dialog.service';
import { CaseFormsService } from '../../../case-forms/case-forms.service';
import { NoteCategoryEnum } from '../../../../models/enum/note-category.enum';
import { NoteTypeEnum } from '../../../../models/enum/note-type.enum';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { MessagingService } from '../../../../services/messaging.service';
import { DatePipe } from '@angular/common';
import { TdoTableSelectionEvent } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { TdoTableEvent } from 'src/app/tdo-controls/common/tdo-table/models/tdo-table.event';
import { Subscription } from 'rxjs';
import {DxDropDownBoxComponent, DxTreeViewComponent} from 'devextreme-angular';


@Component({
    selector: 'app-ar-fee-calculation',
    templateUrl: './ar-fee-calculation.component.html',
    styleUrls: ['./ar-fee-calculation.component.css']
})
export class ArFeeCalculationComponent implements OnInit, OnDestroy {
    @ViewChild(DxTreeViewComponent, { static: false }) treeView: DxTreeViewComponent;
    @ViewChild(DxDropDownBoxComponent, { static: false }) fsdropdown: DxDropDownBoxComponent;

    LOCID: number;
    CaseWorkItemId: string = '';
    PatientId: string = 'F0F6903F-F29E-E711-A59F-6045CB81D461';
    PatientCaseId: string = '9CAC7A96-548E-EA11-A62B-6045CB81D461';
    DoctorId: string = 'CD8EF4FE-B36C-E711-ADF2-005056BE0009';

    deleteMode: boolean = false;
    isLoading: boolean = false;
    isTransactionItemsLoading: boolean = false;
    showPostedTransactions: boolean = false;

    dataPatientCase: DataPatientCaseModel;
    dataTransactionItems: DataARTransactionItemModel[] = [];
    postedTransactionItems: DataARTransactionItemModel[] = [];
    patientCaseWorkItems: DataPatientCaseWorkItemModel[] = [];
    doctorsByTDOCID: DoctorByTDOCIDModel[];
    salutationEnums: EnumValidValueItemModel[] = [];
    enumNoChargeReasons: EnumValidValueItemModel[] = [];
    toothMissingPost: boolean = false;
    OtherMissingPost: boolean = false;
    selectedClaimType: string;

    insuranceOrganizations: PatientInsuranceListViewDataModel[] = [];
    doctorFeeSchedules: FeeScheduleDoctorDataARModel[] = [];
    doctorFeeSchedulesFullList: FeeScheduleDoctorDataARModel[] = [];

    activeDoctorFeeSchedule: FeeScheduleDoctorDataARModel = new FeeScheduleDoctorDataARModel();
    activeOrganization: PatientInsuranceListViewDataModel = new PatientInsuranceListViewDataModel();
    selectedOrganization: PatientInsuranceListViewDataModel = new PatientInsuranceListViewDataModel();
    activeFeeSchedule: FeeScheduleDataModel = new FeeScheduleDataModel();

    selectedInsuranceID: string ;
    selectedDocFeeScheduleID: string;

    patientCoverages: [] = [];
    feeDiscounts: CfgARFeeDiscountModel[] = [];
    feeVariables: FeeVariablesModel;
    locations: LOCIDModel[];

    enumCoverageTypePercent: string = EnumFeeDiscountCalcTypeEnum.Percent;
    enumCoverageTypeAmount: string = EnumFeeDiscountCalcTypeEnum.Money;

    currentDate: Date = new Date();
    isNoChargeCheckboxColor: string = 'var(--tdo-purple-light)';
    emptyGuid: string = Constants.emptyGuid;

    toothList: number[] = Array(32).fill(1).map((x, i) => i + 1);
    sortMode: number = 1;

    selectAll: boolean = false;
    subscriptions: Subscription[] = [];
    organizationFeesLoadedDoctorId: string;

    listOfFeeSchedules: any[] = [];
    treeBoxValue: string | string[] = '1_1';
    isTreeBoxOpened: boolean = false;

    constructor(
        private readonly arService: ARService,
        private readonly dialog: MatDialog,
        private readonly router: Router,
        private readonly snackBar: MatSnackBar,
        public globals: Globals,
        private readonly notesService: NotesService,
        private readonly dialogService: DialogService,
        private readonly caseService: CaseFormsService,
        private readonly messagingService: MessagingService,
        private readonly ref: ChangeDetectorRef
    ) { }


    ngOnInit() {

        const componentCall = this.messagingService.componentMessageCall.subscribe((response) => {
            switch (response.event) {
            case MessagingConstants.DOCTOR_UPDATE:
            case MessagingConstants.CASE_VIEW_ITEM_CHANGED_EVENT:
            // load fee schedule dropdown
                //console.log('change message received: case/doc');
                this.loadOrganizationDoctorFees(response.data.doctorId);
                break;
            }
        });

        this.subscriptions.push(componentCall);

        this.LOCID = parseInt(localStorage.getItem(LOCID));
        this.PatientId = this.globals.currentPatientId;
        this.PatientCaseId = this.globals.currentPatientCaseId;
        this.isLoading = true;

        this.resetNotesFilter('');

        try {
           console.log('ArFeeCalculationComponent PatientId', this.PatientId); 
           this.getPatientInsurance().then((result: boolean) => {
            console.log('ArFeeCalculationComponent getPatientInsurance: ', result); 
            if (this.insuranceOrganizations.length) {
                // patient has an insurance record, proceed
                this.init();
            }
            else {
                // patient has no insurance record, alert user
                this.createMessage_NoDuration('The current patient has no insurance.\n\nPlease visit the Insurance tab, and enter the insurance details for the patient in order to proceed.', 'Dismiss');
                this.isLoading = false;
            }
        });
        console.log('ArFeeCalculationComponent organizations set');
        } catch (err) {
            console.log(err);
            this.createMessage('Something went wrong', 'Error');
            this.isLoading = false;
        }
    }

    getPatientInsurance() {
        const promise = new Promise(async (resolve, reject) => {

            const promises: any[] = [
                this.getInsuranceOrganizations(this.PatientId),
            ];

            try {
                const results: any[] = await Promise.all(promises);
                this.insuranceOrganizations = results[0];
                resolve(true);
            } catch (err) {
                reject(err);
            }
        });
        return promise;
    }

    async init() {

        const promises: any[] = [
            this.getPatientDataTransactionItems(this.PatientId),
            this.getInsuranceOrganizations(this.PatientId),
            this.getDoctorsByTDOCID(),
            this.getPostedPatientDataTransactionItems(this.PatientId),
            this.getLocations(),
            this.getARFeeVariables(),
            this.getListOfFeeSchedules()
        ];

        this.isLoading = true;

        try {

            const results: any[] = await Promise.all(promises);
            this.dataTransactionItems = results[0];
            this.insuranceOrganizations = results[1];
            this.doctorsByTDOCID = results[2];
            this.postedTransactionItems = results[3];
            this.locations = results[4];
            this.feeVariables = results[5];
            this.listOfFeeSchedules = results[6];

            if (this.insuranceOrganizations.length) {



              this.selectedOrganization =  this.insuranceOrganizations.find(f => f.InsuranceOrder == 0);
              this.selectedInsuranceID =this.selectedOrganization.InsuranceID;

                const FeeScheduleID = this.insuranceOrganizations.find(f => f.InsuranceOrder == 0).FeeScheduleID;
                const df = this.listOfFeeSchedules.find(f=> f.ParentID == FeeScheduleID && f.EntityID == this.globals.currentProviderDoctorID);
                if(df) {
                  // find doctor feesched
                  this.treeBoxValue = [df.DocFeeScheduleID];
                }

              if(this.insuranceOrganizations[0].patient_DocFeeScheduleID != null) {
                this.treeBoxValue = [this.insuranceOrganizations[0].patient_DocFeeScheduleID];
              }


              this.activeOrganization = this.insuranceOrganizations[0];

                // load fee schedule dropdown
                this.loadOrganizationDoctorFees(null);
            }

            const transactionCodes: string[] = this.dataTransactionItems.filter(transactionItem => transactionItem.Code).map(transactionItem => transactionItem.Code);

            const coveragePromises: any[] = [
                this.getCoveragesForCodes(this.PatientId, transactionCodes),
            ];

            const coverageResults: any[] = await Promise.all(coveragePromises);
            this.patientCoverages = coverageResults[0];

            this.dataTransactionItems = this.organizeTransactionItems(this.dataTransactionItems, this.patientCoverages, this.activeDoctorFeeSchedule);
            this.dataTransactionItems = this.dataTransactionItems.map(transactionItem => {
                transactionItem.DATA_POST = false;
                transactionItem.DATA_SELECTED_CLAIM = false;
                transactionItem.DATA_SELECTED_TOOTH = '-';

                if (transactionItem.dataPatientCaseWorkItem) {
                    if (transactionItem.dataPatientCaseWorkItem.cfgTooth) {
                        transactionItem.DATA_SELECTED_TOOTH = transactionItem.dataPatientCaseWorkItem.cfgTooth.Name;
                    }
                }

                return transactionItem;
            });

            // show posted items
            this.showPostedTransactions = true;

            this.isLoading = false;

        } catch (err) {
            console.log(err);
            this.createMessage('Something went wrong', 'Error');
            this.isLoading = false;
        }
    }


    // Zoli Changes to insu/fee sched pickers

    onValueChanged_insuranceOrganizations(e) {        
        console.log('onValueChanged_insuranceOrganizations', e);
        console.log('onValueChanged_insuranceOrganizations activeDoctorFeeSchedule start', JSON.parse(JSON.stringify(this.activeDoctorFeeSchedule)));
        if (!e) {
          console.log('onValueChanged_insuranceOrganizations no e');
          return;
        }
        let  _InsuranceID ="";
        if(e?.value)
          _InsuranceID =e.value;
        else
          _InsuranceID =e

        const i = this.insuranceOrganizations.find(f => f.InsuranceID === _InsuranceID )  ;
        console.log('onValueChanged_insuranceOrganizations insurance selected', i);

        this.selectedOrganization = i;
        if (Array.isArray(this.treeBoxValue)) {
            this.treeBoxValue = [];
            this.treeBoxValue.push(i.FeeScheduleID);
        }
        else  {
            this.treeBoxValue = i.FeeScheduleID;
        }



        // find the currect DocFeeScheduleID  based on selected doctor

       let doctorId ="" ;
        if(this.globals.currentProviderDoctorID != "null") {
          doctorId = this.globals.currentProviderDoctorID;
        }
        else {
          doctorId = localStorage.getItem('currentProviderDoctorID');
        }
        console.log('onValueChanged_insuranceOrganizations doctorId', doctorId);

        const df = this.listOfFeeSchedules.find(f => f.ParentID ==  i.FeeScheduleID && f.EntityID == doctorId);

        console.log('onValueChanged_insuranceOrganizations doctorfeeschedule', df);

        if (df != undefined) {
            if (Array.isArray(this.treeBoxValue)) {
                this.treeBoxValue = [];
                this.treeBoxValue.push(df.ObjID);
            } else {
                this.treeBoxValue = df.ObjID;
            }

            this.activeDoctorFeeSchedule.DocFeeScheduleID = df.ObjID;
            this.activeDoctorFeeSchedule.FeeScheduleID = df.ParentID;
        }
        else {
          // doctor does not have FS under this insurance
          // Get default insurance for selected FS org
          console.log('onValueChanged_insuranceOrganizations doctorfeeschedule null, getting default insurance');


          const dfd = this.listOfFeeSchedules.find(f => f.ParentID ==  i.FeeScheduleID && f.fsType == 2);
          console.log('onValueChanged_insuranceOrganizations default insurance schedule', dfd);

          if(dfd != undefined) {
            // dfd.ObjID
            this.treeBoxValue = dfd.ObjID;

            this.activeDoctorFeeSchedule.DocFeeScheduleID = dfd.ObjID;
            this.activeDoctorFeeSchedule.FeeScheduleID = dfd.ParentID;
          }
          else {
            console.log('onValueChanged_insuranceOrganizations default insurance schedule null, getting practice default');

            // get default for the pratice
            const dfp = this.listOfFeeSchedules.find(f =>  f.fsType == 1);
            console.log('onValueChanged_insuranceOrganizations default practice schedule', dfp);

            if(dfp != undefined) {
              // is there one for the doctor?
              console.log('onValueChanged_insuranceOrganizations default practice schedule found, check doctor fee schedule');

              const dfsp = this.listOfFeeSchedules.find(f => f.ParentID == dfp.ObjID &&   f.EntityID == doctorId  );
              console.log('onValueChanged_insuranceOrganizations default practice schedule found, check doctor fee schedule', dfsp);
              if(dfsp != undefined) {
                this.treeBoxValue = dfsp.ObjID;

                this.activeDoctorFeeSchedule.DocFeeScheduleID = dfsp.ObjID;
                this.activeDoctorFeeSchedule.FeeScheduleID = dfsp.ParentID;

              }
              else {
                // pratice default
                console.log('onValueChanged_insuranceOrganizations default doctor schedule not found, check default practice');
                const dfspd = this.listOfFeeSchedules.find(f => f.ParentID == dfp.ObjID &&  f.fsType==2 );
                console.log('onValueChanged_insuranceOrganizations check default practice', dfspd);
                if(dfspd!=undefined) {

                  this.treeBoxValue = dfspd.ObjID;

                  this.activeDoctorFeeSchedule.DocFeeScheduleID = dfspd.ObjID;
                  this.activeDoctorFeeSchedule.FeeScheduleID = dfspd.ParentID;
                }
              }

            }
          }
        }
        console.log('onValueChanged_insuranceOrganizations MID PROCESS activeDoctorFeeSchedule end', JSON.parse(JSON.stringify(this.activeDoctorFeeSchedule)));

      if(this.insuranceOrganizations[0].patient_DocFeeScheduleID != null) {
        this.treeBoxValue = [this.insuranceOrganizations[0].patient_DocFeeScheduleID];

        const zdf = this.listOfFeeSchedules.find(f =>f.ObjID == this.insuranceOrganizations[0].patient_DocFeeScheduleID);

        this.activeDoctorFeeSchedule.DocFeeScheduleID = this.insuranceOrganizations[0].patient_DocFeeScheduleID;
        this.activeDoctorFeeSchedule.FeeScheduleID = zdf.ParentID;

        //console.log( 'DocFeeScheduleID overwritten  2' ,this.treeBoxValue );
      }

      console.log('onValueChanged_insuranceOrganizations activeDoctorFeeSchedule end', JSON.parse(JSON.stringify(this.activeDoctorFeeSchedule)));
      this.ref.detectChanges();
    }



    syncTreeViewSelection() {
        if (!this.treeView) {return; }

        if (this.treeBoxValue) {
            this.treeView.instance.selectItem(this.treeBoxValue);
        } else {
            this.treeView.instance.unselectAll();
        }
    }
    onTreeBoxOptionChanged(e: any) {

    }

  onTreeItemClick(e) {
    if (e.itemData.Level === 1) {
      return ;
    }


    this.fsdropdown.instance.close();

  }
    treeView_itemSelectionChanged(e: any) {
        console.log('treeView_itemSelectionChanged', e);
        console.log('treeView_itemSelectionChanged activeDoctorFeeSchedule start', this.activeDoctorFeeSchedule);
        if (e.itemData.Level === 1) {
            return ;
        }

        const nodes = e.component.getSelectedNodeKeys();
        if (nodes.length == 0)
            return;

        this.treeBoxValue = nodes;

        if (Array.isArray(this.treeBoxValue)) {
            this.activeDoctorFeeSchedule.DocFeeScheduleID = this.treeBoxValue[0];
            this.selectedDocFeeScheduleID = this.treeBoxValue[0];
        }
        else  {
            this.activeDoctorFeeSchedule.DocFeeScheduleID = this.treeBoxValue;
            this.selectedDocFeeScheduleID = this.treeBoxValue;
        }

        const i = this.listOfFeeSchedules.find(f => f.ObjID == this.selectedDocFeeScheduleID );
        this.activeDoctorFeeSchedule.FeeScheduleID = i.ParentID;

        if(!this.initialLoad) {

          this.dialogService.openConfirmDialog('Do you want to change the FeeSchedule for this patient permanently? ').subscribe((isConfirmed) => {
            if (isConfirmed) {
              this.arService.savePatientOverwriteFeeSchedule(  this.PatientId , this.selectedDocFeeScheduleID).subscribe(res => {
                console.log(res);
              });
            }
          });
        }
        this.initialLoad =false;
        console.log('treeView_itemSelectionChanged activeDoctorFeeSchedule end', this.activeDoctorFeeSchedule);
    }


    onClickHelpEtimate()  {

      this.dialogService.openConfirmDialog(

        'Pratice operates under Insurance Estimation Rules.<br/><br/>' +
        'Fee schedule can not be changed for a patient with an active insurance.<br/>'+
        'Change the fee schedule on the insurance carrier profile instead.', false, false, 'Insurance Estimation is Active').subscribe((isConfirmed) => {});

    }

    initialLoad=true;

    onTreeViewonContentReady(e) {

        this.initialLoad=true;

        if(this.feeVariables?.ARisEstimating===true)
        {
          console.log('can not change fee schedule', e);

          return;
        }



        // e.component.selectItem(this.treeBoxValue)

        const df = this.listOfFeeSchedules.find(f => f.ObjID ==  this.treeBoxValue );
        if (df == undefined)
            return;

        if (e == undefined) {
            this.treeView.instance.unselectAll();
            this.treeView.instance.collapseAll();


            this.treeView.instance.expandItem(df.ParentID).then(() => {
              if (Array.isArray(this.treeBoxValue)) {
                this.treeView.instance.selectItem(this.treeBoxValue[0]);
              }
              else {
                this.treeView.instance.selectItem(this.treeBoxValue);
              }
            });
        }
        else {
            e.component.unselectAll();
            e.component.collapseAll();

            if (df.Level == 2) {
                e.component.expandItem(df.ParentID).then(() => {
                  if (Array.isArray(this.treeBoxValue)) {
                    e.component.selectItem(this.treeBoxValue[0]).th;
                  }
                  else {
                    e.component.selectItem(this.treeBoxValue);

                  }
                });
            } 
        }

    }

    // Zoli Changes to insu/fee sched pickers  END

    loadPatientTransactionItems() {
        this.isLoading = true;
        this.getPatientDataTransactionItems(this.PatientId).then((result: DataARTransactionItemModel[]) => {
            if (result != null) {
                this.dataTransactionItems = result;
                this.isLoading = false;
            }
        });
    }

    loadPostedPatientTransactionItems() {
        this.getPostedPatientDataTransactionItems(this.PatientId).then((result: DataARTransactionItemModel[]) => {
            if (result != null) {
                this.postedTransactionItems = result;
            }
        });
    }

    getPatient(PatientId: string) {
        return this.arService.getPatient(PatientId).toPromise();
    }

    getLedgerForPatient(PatientId: string) {
        return this.arService.getLedgerForPatient(PatientId).toPromise();
    }

    getAppointmentInformation(PatientCaseId: string) {
        return this.arService.getAppointmentInformation(PatientCaseId).toPromise();
    }

    calcTransactionsSelected() {
        let flag = false;
        flag = this.dataTransactionItems.some(transactionItem => transactionItem.DATA_POST);
        return flag;
    }

    calcClaimsSelected() {
        let flag = false;

        this.dataTransactionItems.forEach(ledgerItem => {
            if (ledgerItem.DATA_SELECTED_CLAIM) {
                flag = true;
            }
        });

        return flag;
    }

    navigateTo(path) {
        this.router.navigate([path]);
    }

    resetNotesFilter(objectId: string = '') {
        const model = new TdoNoteQueryModel();
        model.parentObjectName = 'dataARTransactionItems';
        model.objectId = objectId;
        model.patientId = this.globals.currentPatientId;
        model.categoryEnumId = NoteCategoryEnum.Fee;
        model.typeEnumId = NoteTypeEnum.Patient;
        this.notesService.changeNoteQuery(model);
    }
    setPostDate(transactionItem: DataARTransactionItemModel) {
        transactionItem.PostDate = new Date();
    }

    setPresentedDate(transactionItem: DataARTransactionItemModel) {
        transactionItem.PresentedDate = new Date();
    }

    returnErrorList(transactionItem: DataARTransactionItemModel, itemNumber: number) {
        const errorObject = new ARFeeErrorItem();

        this.checkCode(transactionItem, errorObject);
        this.checkPrices(transactionItem, errorObject);
        this.checkDates(transactionItem, errorObject);
        this.checkDoctor(transactionItem, errorObject);
        this.checkTooth(transactionItem, errorObject);

        if (errorObject.errorListRequired.length > 0 || errorObject.errorListOptional.length > 0) {
            errorObject.transactionItemCode = transactionItem.Code ? transactionItem.Code : 'Unknown Code';
            errorObject.transactionItemNumber = itemNumber;
        }

        return errorObject;
    }

    private checkCode(transactionItem: DataARTransactionItemModel, errorObject: ARFeeErrorItem) {
        if (transactionItem.Code) {
            if (transactionItem.Code.trim() === '') {
                errorObject.errorListRequired.push('Procedure Code');
                this.OtherMissingPost = true;
            }
        } else {
            errorObject.errorListRequired.push('Procedure Code');
            this.OtherMissingPost = true;
        }
    }

    private checkPrices(transactionItem: DataARTransactionItemModel, errorObject: ARFeeErrorItem) {
        if (transactionItem.Price === null) {
            errorObject.errorListRequired.push('Original Price');
            this.OtherMissingPost = true;
        }
        if (transactionItem.DoctorsPrice === null) {
            errorObject.errorListRequired.push('Doctors Price');
            this.OtherMissingPost = true;
        }
        if (transactionItem.DeductibleAmount === null) {
            errorObject.errorListRequired.push('Deductible');
            this.OtherMissingPost = true;
        }
        if (transactionItem.PriceAdjusted === null) {
            errorObject.errorListRequired.push('Fee');
            this.OtherMissingPost = true;
        }
        if (transactionItem.InsuranceAmount === null) {
            errorObject.errorListRequired.push('Insurance Amount');
            this.OtherMissingPost = true;
        }
        if (transactionItem.PatientResponsibility === null) {
            errorObject.errorListRequired.push('Patient');
            this.OtherMissingPost = true;
        } else if (transactionItem.PatientResponsibility <= 0) {
            errorObject.errorListRequired.push('Patient fee cannot be zero');
            this.OtherMissingPost = true;
        }
    }

    private checkDates(transactionItem: DataARTransactionItemModel, errorObject: ARFeeErrorItem) {
        if (transactionItem.PostDate === null) {
            errorObject.errorListRequired.push('Post Date');
            this.OtherMissingPost = true;
        }
    }

    private checkDoctor(transactionItem: DataARTransactionItemModel, errorObject: ARFeeErrorItem) {
        if (transactionItem.ProviderDoctorId === null || transactionItem.ProviderDoctorId === this.emptyGuid) {
            errorObject.errorListRequired.push('Doctor');
            this.OtherMissingPost = true;
        }
    }

    private checkTooth(transactionItem: DataARTransactionItemModel, errorObject: ARFeeErrorItem) {
        if (transactionItem.TeethReference) {
            if (transactionItem.TeethReference === '') {
                errorObject.errorListRequired.push('Tooth');
                this.OtherMissingPost = true;
            }
        } else {
            errorObject.errorListRequired.push('Tooth');
            this.OtherMissingPost = true;
        }
    }

    async postSelectedTransactions(blIgnoreMissingTeeth: boolean) {

        let blError = false;
        let numRowCount: number = 0;
        const errorObject = new ARFeeErrors();

        this.toothMissingPost = false;
        this.OtherMissingPost = false;

        this.dataTransactionItems.forEach(transactionItem => {
            if (transactionItem.DATA_POST) {

                // check for completed fields
                numRowCount++;

                const errorObjectTemp = this.returnErrorList(transactionItem, numRowCount);
                if (errorObjectTemp.transactionItemNumber) {
                    errorObject.ARFeeErrorItems.push(errorObjectTemp);
                    blError = true;
                }
            }
        });
        if (blError) {
            this.openPostItemsError(errorObject, null, false);
        }
        else {

            const transactionsToPost: DataARTransactionItemModel[] = [];
            this.dataTransactionItems.forEach(transactionItem => {
                if (transactionItem.DATA_POST) {
                    transactionItem.PostDate = this.currentDate;
                    transactionsToPost.push(transactionItem);
                }
            });

            if (!transactionsToPost.length) {
                return;
            }

            const postTransItems = new PostTransactionItemModel();
            postTransItems.LOCID = this.LOCID;
            postTransItems.PatientId = this.PatientId;
            postTransItems.transactionItems = transactionsToPost;
            postTransItems.ProviderDoctorId = this.globals.currentProviderDoctorID;

            this.isLoading = true;

            try {
                await this.arService.postTransactionItems(postTransItems).toPromise();
                this.createMessage('Transaction(s) posted', 'Success');
            } catch (err) {
                console.log(err);
                this.createMessage('Something went wrong', 'Error');
            }

            this.isLoading = false;
            this.loadPatientTransactionItems();
            this.loadPostedPatientTransactionItems();
        }
    }

    openClaimWizardYN() {
        const ignoreMissingTeeth = false;
        const claimType = this.selectedClaimType;
        if (claimType === 'real') {
            this.dialogService.openConfirmDialog('Proceeding will result in selected fees being posted to the ledger.').subscribe((res) => {
                if (res) {
                    this.openClaimWizard(ignoreMissingTeeth);
                }
            });
        }
        else {
            this.openClaimWizard(ignoreMissingTeeth);
        }
    }

    openClaimWizard(blIgnoreMissingTeeth: boolean) {

        const claimType = this.selectedClaimType;
        let blError = false;
        let numRowCount: number = 0;
        const errorObject = new ARFeeErrors();

        this.toothMissingPost = false;
        this.OtherMissingPost = false;

        this.dataTransactionItems.forEach(transactionItem => {
            if (transactionItem.DATA_POST) {

                // check for completed fields
                numRowCount++;

                const errorObjectTemp = this.returnErrorList(transactionItem, numRowCount);
                if (errorObjectTemp.transactionItemNumber) {
                    errorObject.ARFeeErrorItems.push(errorObjectTemp);
                    blError = true;
                }
            }
        });

        let claimEnumType = '';
        if (claimType === 'pre') {
            claimEnumType = ClaimTypeEnum.Predetermination;
        }
        else if (claimType === 'real') {
            claimEnumType = ClaimTypeEnum.RealClaim;
        }

        // if there are items with incomplete fields
        if (blError && !blIgnoreMissingTeeth) {
            if (this.OtherMissingPost) {
                this.openClaimsItemsError(errorObject, null, false);
            }
            else {
                this.openClaimsItemsError(null, 'One or more transactions do not have a tooth specified.\n\nAre you sure that you would like to continue with the claim?', true);
            }
        }
        else {

            // build list of transaction items to claim
            const transactionsToClaim: DataARTransactionItemModel[] = [];
            this.dataTransactionItems.forEach(transactionItem => {
                if (transactionItem.DATA_POST) {
                    transactionItem.PostDate = this.currentDate;
                    transactionsToClaim.push(transactionItem);
                }
            });

            if (transactionsToClaim.length > 0) {
                // only open dialog if transactions were selected and are valid
                const dialogRef = this.dialog.open(ClaimWizardComponent, {
                    width: '1200px',
                    height: '800px',
                    panelClass: 'dialog',
                    data: {
                        PatientId: this.PatientId,
                        dataTransactionItems: transactionsToClaim,
                        postedTransactionItems: this.postedTransactionItems,
                        doctors: this.doctorsByTDOCID,
                        selectedClaimType: claimEnumType
                        // the call to get this.dataPatient in onInit takes forever then dies, need to rewrite
                        // dataPatient: this.dataPatient,
                    }
                });
                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        this.init();
                    }
                }, err => {
                });
            }
        }
    }

    calculateNewCoverageAmountForItems(_) {
        this.dataTransactionItems = this.organizeTransactionItems(this.dataTransactionItems, this.patientCoverages, this.activeDoctorFeeSchedule);
        this.saveAllTransactionItems(false);
    }

    editDetailForTransaction(transactionItem: DataARTransactionItemModel, key: string) {
        transactionItem[key] = true;

        if (key === 'DATA_ENABLE_TOOTH_EDIT') {
            this.openCaseWorkItemPickerForTransactionItem(transactionItem);
        }
        else if (key === 'DATA_ENABLE_TOOTH_SURFACE_EDIT') {
            this.openCaseWorkItemToothSurfacePickerForCaseWorkItemID(transactionItem.CaseWorkItemId);
        }
        else if (key === 'DATA_ENABLE_CODE_EDIT') {
            this.openCodePickerForTransaction(transactionItem);
        }
    }

    calculateCostForItem(transactionItem: DataARTransactionItemModel, showLoading: boolean = false, overridePrice: boolean = false, saveAfter: boolean = false) {
        const promise = new Promise(async (resolve, reject) => {

            if (showLoading) {
                this.isLoading = true;
            }

            try {
                const doctorFee: FeeScheduleItemFeeDataModel = await this.arService.getDoctorFeeForCode(transactionItem.DATA_DOCTOR_FEE_SCHEDULE.DocFeeScheduleID, transactionItem.Code).toPromise();

                if (doctorFee) {
                    transactionItem.DATA_ACTIVE_DoctorFee = doctorFee;
                    this.setTransactionDetails(transactionItem, overridePrice);
                } else {
                    // show warning?
                }

                if (showLoading) {
                    this.isLoading = false;
                }

                if (saveAfter) {
                    this.saveTransactionItem(transactionItem);
                }

                resolve(transactionItem);

            } catch (err) {
                reject(err);
            }

        });
        return promise;
    }

    setTransactionDetails(transactionItem: DataARTransactionItemModel, overridePrice: boolean = false) {

        if (overridePrice || transactionItem.CoverageAmount == null || typeof transactionItem.CoverageAmount === 'undefined') {
            transactionItem.CoverageAmount = transactionItem.DATA_ACTIVE_PatientCoverage.CoverageAmount;
        }

        if (overridePrice || transactionItem.CoveragePCT == null || typeof transactionItem.CoveragePCT === 'undefined') {
            transactionItem.CoveragePCT = transactionItem.DATA_ACTIVE_PatientCoverage.CoveragePCT;
        }

        if (overridePrice || transactionItem.Price == null || typeof transactionItem.Price === 'undefined') {
            transactionItem.Price = transactionItem.DATA_ACTIVE_DoctorFee.Fee;
        }

        if (overridePrice || transactionItem.PriceAdjusted == null || typeof transactionItem.PriceAdjusted === 'undefined') {
            transactionItem.PriceAdjusted = this.calculateCost(transactionItem, 'patient');
        }

        if (overridePrice || transactionItem.enumFeeCoverageCalcTypeId == null || typeof transactionItem.enumFeeCoverageCalcTypeId === 'undefined') {
            transactionItem.enumFeeCoverageCalcTypeId = transactionItem.DATA_ACTIVE_PatientCoverage.enumFeeCoverageCalcTypeId;
        }

    }

    organizeTransactionItems(dataTransactionItems: DataARTransactionItemModel[], patientCoverages: PatientInsuranceCoverageARDataModel[], activeDoctorFeeSchedule: any) {

        dataTransactionItems.forEach(transactionItem => {

            transactionItem.DATA_ACTIVE_PatientCoverage = new PatientInsuranceCoverageARDataModel();
            transactionItem.DATA_ACTIVE_DoctorFee = new FeeScheduleItemFeeDataModel();

            transactionItem.DATA_PatientCoverages = patientCoverages.filter(patientCoverage => patientCoverage.Code === transactionItem.Code);
            transactionItem.DATA_PatientCoverages.forEach(patientCoverage => {
                patientCoverage.DATA_DoctorFees = [];
            });

            if (transactionItem.DATA_PatientCoverages.length) {
                transactionItem.DATA_ACTIVE_PatientCoverage = transactionItem.DATA_PatientCoverages[0];

                if (transactionItem.DATA_ACTIVE_PatientCoverage.DATA_DoctorFees.length) {
                    transactionItem.DATA_ACTIVE_DoctorFee = transactionItem.DATA_ACTIVE_PatientCoverage.DATA_DoctorFees[0];
                }

            } else {
                // no coverages
            }

        });

        return dataTransactionItems;
    }

    calculateCost(transactionItem: DataARTransactionItemModel, billTo: string) {

        try {
            let doctorFee: number;
            if (transactionItem.Price != null) {
                doctorFee = transactionItem.Price;
            } else {
                doctorFee = transactionItem.DATA_ACTIVE_DoctorFee.Fee;
            }

            let insuranceCoverage: number;

            if (transactionItem.DATA_ACTIVE_PatientCoverage.enumFeeCoverageCalcTypeId === this.enumCoverageTypeAmount) {
                insuranceCoverage = transactionItem.DATA_ACTIVE_PatientCoverage.CoverageAmount;
            } else {
                insuranceCoverage = (doctorFee * (transactionItem.DATA_ACTIVE_PatientCoverage.CoveragePCT / 100));
            }

            if (typeof doctorFee === 'undefined' || isNaN(doctorFee)) {
                return 0;
            }

            if (typeof insuranceCoverage === 'undefined' || isNaN(insuranceCoverage)) {
                return 0;
            }

            if (billTo === 'insurance') {
                return insuranceCoverage;
            } else {

                const billableToPatient = doctorFee - insuranceCoverage;
                if (billableToPatient < 0) {
                    return 0;
                }

                return billableToPatient;
            }
        } catch (err) {
            return 0;
        }

    }

    async removeSelectedItems() {

        const selectedItems = this.dataTransactionItems.filter(transactionItem => transactionItem.DATA_POST);

        const promises = selectedItems.map(transactionItem => this.deleteTransactionItem(transactionItem));

        this.isLoading = true;

        try {
            const results: any[] = await Promise.all(promises);
            this.createMessage('Items removed', 'Success');
        } catch (err) {
            this.createMessage('Something went wrong', 'Error');
        }

        this.isLoading = false;
        this.loadPatientTransactionItems();
    }

    async removeTransactionItem(transactionItem, index) {
        this.dataTransactionItems.splice(index, 1);
        try {
            await this.deleteTransactionItem(transactionItem);
            this.createMessage('Item removed', 'Success');
        } catch (err) {
            console.log(err);
            this.createMessage('Something went wrong', 'Error');
        }
    }

    deleteTransactionItem(transactionItem: any) {
        return this.arService.deleteTransactionItem(transactionItem).toPromise();
    }

    getDataPatientCase(PatientCaseId: string) {
        return this.arService.getDataPatientCase(PatientCaseId).toPromise();
    }

    getDoctorFeesForCodes(DoctorId: string, FeeScheduleId: string, codes: string[]) {
        return this.arService.getDoctorFeesForCodes(DoctorId, FeeScheduleId, codes).toPromise();
    }

    getPatientDataTransactionItems(PatientId: string) {
        return this.arService.getPatientDataTransactionItems(PatientId).toPromise();
    }

    getPostedPatientDataTransactionItems(PatientId: string) {
        return this.arService.getPostedPatientDataTransactionItems(PatientId).toPromise();
    }

    getPatientDataTransactionItemsByPatientCase(PatientCaseId: string) {
        return this.arService.getPatientDataTransactionItemsByPatientCase(PatientCaseId).toPromise();
    }

    getCaseWorkItems(PatientId: string) {
        return this.arService.getCaseWorkItems(PatientId).toPromise();
    }

    getFeeScheduleItems(FeeScheduleId: string) {
        return this.arService.getFeeScheduleItems(FeeScheduleId).toPromise();
    }

    getCoveragesForCodes(PatientId: string, codes: string[]) {
        return this.arService.getCoveragesForCodes(PatientId, codes).toPromise();
    }

    getInsuranceOrganizations(PatientId: string) {
        return this.arService.getInsuranceOrganizations(PatientId).toPromise();
    }

    getInsuranceDoctorFees(OrganizationId: string) {
        return this.arService.getInsuranceDoctorFees(OrganizationId).toPromise();
    }
    getInsuranceDoctorFeesForPatient(PatientId: string) {
        return this.arService.getInsuranceDoctorFeesForPatient(PatientId).toPromise();
    }

    postSaveTransactionUpdateFees(transactionItem: DataARTransactionItemModel, PatientID: string, itemChanged: number) {
        return this.arService.saveTransactionItemUpdateFees(transactionItem, PatientID, itemChanged).toPromise();
    }

    getFeeSchedules() {
        return this.arService.getFeeSchedules().toPromise();
    }

    async saveAllTransactionItems(toggleLoading: boolean = true) {

        if (toggleLoading) {
            this.isLoading = true;
        }

        const promises = this.dataTransactionItems.map(transactionItem => this.saveTransactionItem(transactionItem));

        try {
            await Promise.all(promises);
        } catch (err) {
            console.log('err', err);
            this.createMessage('Something went wrong', 'Error');
        }

        if (toggleLoading) {
            this.isLoading = false;
        }
    }

    saveTransactionItem(transactionItem) {
        const itemClone = JSON.parse(JSON.stringify(transactionItem));
        itemClone.dataARTransaction = null;
        itemClone.dataPatientCaseWorkItem = null;
        itemClone.DATA_cfgCaseProcedure = null;
        itemClone.dataARClaims = [];
        itemClone.dataDoctor = null;
        return this.arService.saveTransactionItem(itemClone).toPromise();
    }

    // saveTransactionItemUpdateFees(transactionItem: DataARTransactionItemModel, PatientID: string, itemChanged: number) {
    //   this.isTransactionItemsLoading = true;
    //   this.postSaveTransactionUpdateFees(transactionItem, PatientID, itemChanged).then((result) => {
    //       if (result != null) {
    //         this.dataTransactionItems = result;
    //         this.isTransactionItemsLoading = false;
    //       }
    //     }
    //   );
    // }

    createMessage(message, type) {
        this.snackBar.open(message, type, {
            duration: 6000,
            verticalPosition: 'top',
            panelClass: ['snackbar-linebreaks']
        });
    }

    createMessage_NoDuration(message, type) {
        this.snackBar.open(message, type, {
            verticalPosition: 'top',
            panelClass: ['snackbar-linebreaks']
        });
    }

    createClaim(transactionItem: any) {
        const payload: DataARClaimModel = new DataARClaimModel();
        payload.PatientInsuranceID = transactionItem.this.activeOrganization.OrganizationID;
        return this.arService.saveDataClaim(payload).toPromise();
    }

    sortTransactionItems(transactionItems: DataARTransactionItemModel[], sortType: string) {

        this.sortMode *= -1;

        let sortFunction;
        switch (sortType) {
        case 'procedure':
            sortFunction = (a, b) => {
                const val1 = a.dataPatientCaseWorkItem.cfgCaseProcedure.ProcedureName;
                const val2 = b.dataPatientCaseWorkItem.cfgCaseProcedure.ProcedureName;
                if (val1 < val2) {
                    return (-1 * this.sortMode);
                } else if (val1 > val2) {
                    return (1 * this.sortMode);
                } else {
                    return 0;
                }
            };
            break;
        case 'code':
            sortFunction = (a, b) => {
                const val1 = a.Code;
                const val2 = b.Code;
                if (val1 < val2) {
                    return (-1 * this.sortMode);
                } else if (val1 > val2) {
                    return (1 * this.sortMode);
                } else {
                    return 0;
                }
            };
            break;
        case 'fee':
            sortFunction = (a, b) => {
                const val1 = a.DATA_ACTIVE_DoctorFee.Fee || 0;
                const val2 = b.DATA_ACTIVE_DoctorFee.Fee || 0;
                return (val1 - val2) * this.sortMode;
            };
            break;
        case 'insurance':
            sortFunction = (a, b) => {
                const val1 = this.calculateCost(a, 'insurance');
                const val2 = this.calculateCost(b, 'insurance');
                return (val1 - val2) * this.sortMode;
            };
            break;
        case 'patient':
            sortFunction = (a, b) => {
                const val1 = this.calculateCost(a, 'patient');
                const val2 = this.calculateCost(b, 'patient');
                return (val1 - val2) * this.sortMode;
            };
            break;
        case 'postedDate':
            sortFunction = (a, b) => {
                const val1: Date = new Date(a.DATA_POST_DATE);
                const val2: Date = new Date(b.DATA_POST_DATE);
                return (val1.getTime() - val2.getTime()) * this.sortMode;
            };
            break;
        }

        transactionItems = transactionItems.sort(sortFunction);
    }

    selectAllTransactions() {

        if (this.isLoading || !this.dataTransactionItems.length) {
            return;
        }

        if (this.selectAll) {
            this.dataTransactionItems.forEach(transactionItem => {
                transactionItem.DATA_POST = true;
            });
        }
        else {
            this.dataTransactionItems.forEach(transactionItem => {
                transactionItem.DATA_POST = false;
            });
        }
    }

    transactionItemIsValid(transactionItem: DataARTransactionItemModel) {
    // check for completed fields
        if (transactionItem.Price === null
      || transactionItem.PriceAdjusted === null
      || transactionItem.InsuranceAmount === null
      || transactionItem.PatientResponsibility === null
      || transactionItem.DeductibleAmount === null
      || transactionItem.PostDate === null
      // || transactionItem.PresentedDate === null
      || transactionItem.ProviderDoctorId === null
      || (transactionItem.ToothID === null || transactionItem.ToothID === '00000000-0000-0000-0000-000000000000')
        ) {
            return false;
        }
        else {
            return true;
        }
    }

    loadOrganizationDoctorFees(doctorId: string) {

        if( doctorId) {
          this.organizationFeesLoadedDoctorId = doctorId;
        }
        else {
          doctorId = localStorage.getItem('currentProviderDoctorID');

          this.organizationFeesLoadedDoctorId = doctorId;
        }

        this.onValueChanged_insuranceOrganizations(this.selectedOrganization.InsuranceID);
    }


    private setDoctorFeeSchedulesForPatient(result: FeeScheduleDoctorDataARModel[], doctorId: string) {
        console.log('setDoctorFeeSchedulesForPatient start', this.activeDoctorFeeSchedule);
        this.doctorFeeSchedulesFullList = result;
        this.doctorFeeSchedules = this.doctorFeeSchedulesFullList.filter(a => a.OrganizationID === this.activeOrganization?.OrganizationID);
        this.activeDoctorFeeSchedule = null;

        if (!doctorId) {
            doctorId = this.globals.currentProviderDoctorID;
        }

        if (doctorId) {
            this.activeDoctorFeeSchedule = this.doctorFeeSchedules.find(a => a.DoctorId === doctorId);


            if (this.activeDoctorFeeSchedule == null) {
                // the doctor under insurance company dose not have a fee schedule
                // look for default fee schedule for insurance company for this practice
                this.doctorFeeSchedulesFullList.forEach(a => {
                    if (a.OrganizationID == this.activeOrganization?.OrganizationID && a.DoctorId === a.default_FeeSch_DoctorId) {
                        this.activeDoctorFeeSchedule = a;
                        this.doctorFeeSchedules = [];
                        this.doctorFeeSchedules = this.doctorFeeSchedulesFullList.filter(b => b.OrganizationID === a.OrganizationID);

                    }

                });
            }
            if (this.activeDoctorFeeSchedule == null) {
                // no default fee schedule for insurance company practice
                // look for default fee schedule for doctor under UTC (default fees hed for pratice)
                this.activeOrganization = this.insuranceOrganizations.filter(a => a.isDefault)[0];
                this.doctorFeeSchedulesFullList.forEach(a => {
                    if (a.OrganizationID == this.activeOrganization?.OrganizationID && a.DoctorId === doctorId) {
                        this.activeDoctorFeeSchedule = a;
                        this.doctorFeeSchedules = [];
                        this.doctorFeeSchedules = this.doctorFeeSchedulesFullList.filter(b => b.OrganizationID === a.OrganizationID);
                    }
                });
            }

            if (this.activeDoctorFeeSchedule == null) {
                // if still not found use practice default UTC
                this.doctorFeeSchedulesFullList.forEach(a => {
                    if (a.OrganizationID == this.activeOrganization?.OrganizationID && a.DoctorId === a.default_FeeSch_DoctorId) {
                        this.activeDoctorFeeSchedule = a;
                        this.doctorFeeSchedules = [];
                        this.doctorFeeSchedules = this.doctorFeeSchedulesFullList.filter(b => b.OrganizationID === a.OrganizationID);
                    }
                });
            }
        }

        if (Array.isArray(this.treeBoxValue)) {
            this.treeBoxValue = [];
            this.treeBoxValue.push( this.activeDoctorFeeSchedule.DocFeeScheduleID);
        }
        else  {
            this.treeBoxValue =  this.activeDoctorFeeSchedule.DocFeeScheduleID;
        }

        if (this.doctorFeeSchedules.length === 0) {
            this.createMessage('A fee schedule has not been created for the selected insurance. One must be created in order to add procedures.', 'Warning');
        }
        console.log('setDoctorFeeSchedulesForPatient end', this.activeDoctorFeeSchedule);
    }


    openCreateTransactionItemComponent() {
        if (this.doctorFeeSchedules.length === 0) {
            this.createMessage('A fee schedule has not been created for the selected insurance. One must be created in order to select procedures.', 'Warning');
        }
        else if (this.globals.currentPatientCaseWorkItemID === '') {
            this.createMessage('Please select a Case/Procedure to create a fee for patient in Case View', 'Warning');
        }
        else {
            // if we get this far, then we need to make sure that a tooth exists before proceeding
            this.loadCreateFeeIfRequirementsMet(this.globals.currentPatientCaseWorkItemID);
        }
    }

    openCodePickerForTransaction(transactionItem: DataARTransactionItemModel) {
    // open window
        const dialogRef = this.dialog.open(ArCreateTransactionComponent, {
            width: '800px',
            height: '650px',
            data: {
                PatientId: this.PatientId,
                PatientCaseId: this.PatientCaseId,
                DoctorId: this.activeDoctorFeeSchedule.DoctorId,
                feeScheduleID: this.activeDoctorFeeSchedule.FeeScheduleID,
                isCodeEdit: true,
                procedureCode: transactionItem.Code,
                ToothID: transactionItem.ToothID,
                TransactionDate: new Date(),
                OrganizationID: this.activeOrganization.OrganizationID,
                PatientInsuranceID: this.activeOrganization.PatientInsuranceID,
                DocFeeScheduleID: this.activeDoctorFeeSchedule.DocFeeScheduleID,
                caseWorkItemID: transactionItem.CaseWorkItemId
            }
        });

        // window closed
        dialogRef.afterClosed().subscribe(async result => {

            if (!result) {
                return;
            } else {
                // reload list
                // this.init();
                this.loadPatientTransactionItems();
            }
        }, err => {
        });
    }

    openCaseWorkItemPickerForTransactionItem(transactionItem: DataARTransactionItemModel) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'dialog';
        dialogConfig.data = {
            isMultiSelect: false,
            PatientCaseId: this.PatientCaseId,
            TransactionItem: transactionItem
        };

        const dialogRef = this.dialog.open(CaseItemSelectComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(async result => {
            if (result) {
                this.loadPatientTransactionItems();
            }
        }, err => {
        });

    }

    openCaseWorkItemToothSurfacePickerForCaseWorkItemID(CaseWorkItemID: string) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'dialog';
        dialogConfig.data = {
            isMultiSelect: false,
            caseWorkItemId: CaseWorkItemID
        };

        const dialogRef = this.dialog.open(ToothSurfacePickerComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(async result => {
            if (result) {
                this.loadPatientTransactionItems();
            }
        }, err => {

        });
    }

    openToothPickerForTransactionItem(transactionItem: DataARTransactionItemModel) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'dialog';
        dialogConfig.data = new ToothPickerConfigModel();
        dialogConfig.data.isMultiSelect = false;
        const dialogRef = this.dialog.open(ToothPickerComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(async result => {

            if (!result) {
                return;
            }

            // array of teeth
            const teeth: DataPatientCaseWorkItemToothModel[] = [];

            // update view with change
            transactionItem.Notation = '';
            result.forEach(p => {
                transactionItem.Notation += p.toothModel.cfgToothDescriptions[0].Notation + ', ';

                const tooth = new DataPatientCaseWorkItemToothModel();
                tooth.ToothID = p.toothModel.ToothId;
                tooth.CaseWorkItemId = transactionItem.CaseWorkItemId;
                teeth.push(tooth);
            });

            // clean up string
            if (transactionItem.Notation !== '') {
                transactionItem.Notation = transactionItem.Notation.trimEnd().slice(0, transactionItem.Notation.length - 2);
            }

            // save to dataPatientCaseWorkItemTeeth
            try {
                await this.updateDataPatientCaseWorkItemTeeth(teeth, transactionItem.CaseWorkItemId);
            } catch (err) {
                console.log('err');
            }

        }, err => {
        });
    }

    updateDataPatientCaseWorkItemTeeth(teeth, CaseWorkItemId) {
        return this.arService.updateDataPatientCaseWorkItemTooth(teeth, CaseWorkItemId).toPromise();
    }

    getDoctorsByTDOCID() {
        return this.arService.getDoctorsByTDOCIDFees().toPromise();
    }

    // getDoctorsByLOCID() {
    //   return this.arService.getDoctorsByLOCID(this.transactionItem.LOCID).toPromise();
    // }

    returnSalutation(enumValue: string) {

        if (enumValue) {
            enumValue = enumValue.toUpperCase();
            if (enumValue === SalutationEnum.Dr) {
                return 'Dr. ';
            }
            else if (enumValue === SalutationEnum.Prof) {
                return 'Prof. ';
            }
            else if (enumValue === SalutationEnum.Mr) {
                return 'Mr. ';
            }
            else {
                return '';
            }
        } else {
            return '';
        }
    }


    getListOfFeeSchedules()  {
        return this.arService.getListOfFeeScedules().toPromise();
    }

    getARFeeVariables() {
        return this.arService.getARVariablesByTDOCID().toPromise();
    }

    getLocations() {
        return this.arService.getLocations().toPromise();
    }

    // discounts

    // getDiscounts() {
    //   return this.arService.getDiscounts().toPromise();
    // }

    // getDiscountForDoctor(doctorId, level) {
    //   return this.arService.getDiscountForDoctor(doctorId, level).toPromise();
    // }

    isDiscountApplied(discountId: string, level: number) {
        const feeDiscount = this.feeDiscounts.find(a => a.DiscountID === discountId && a.DiscountName === 'Level' + level);
        if (feeDiscount) {
            return true;
        }
        else {
            return false;
        }
    }

    removeDiscountOnServerService(transactionItem: DataARTransactionItemModel) {
        return this.arService.removeDiscountOnServer(transactionItem).toPromise();
    }

    applyDiscountOnServerService(transactionItem: DataARTransactionItemModel, level: number) {
        return this.arService.applyDiscountOnServer(transactionItem, level, this.PatientId).toPromise();
    }

    applyDiscount(transactionItem: DataARTransactionItemModel, level: number) {
        this.isTransactionItemsLoading = true;

        // first check to see if discount is applied or not
        if (this.isDiscountApplied(transactionItem.DiscountID, level)) {

            // discount already applied, remove it
            this.removeDiscountOnServerService(transactionItem).then(
                (result) => {
                    if (result != null) {
                        // reload grid
                        this.getPatientDataTransactionItems(this.PatientId).then(
                            (transResults) => {
                                this.dataTransactionItems = transResults;
                                this.isTransactionItemsLoading = false;
                            }
                        );
                    }
                }
            );
        }
        else {

            // discount not applied, apply it
            this.applyDiscountOnServerService(transactionItem, level).then(
                (result) => {
                    if (result != null) {
                        // reload grid
                        this.getPatientDataTransactionItems(this.PatientId).then(
                            (transResults) => {
                                this.dataTransactionItems = transResults;
                                this.isTransactionItemsLoading = false;
                            }
                        );
                    }
                }
            );
        }
    }

    getDiscountAmountForTooltip(transactionItem: DataARTransactionItemModel, level: number) {
        const feeDiscount = this.feeDiscounts.find(a =>
            a.DiscountName === 'Level' + level
      && a.ProviderDoctorId === transactionItem.ProviderDoctorId
      && a.LOCID === this.LOCID);
        if (feeDiscount) {
            if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Percent) {
                return feeDiscount.DiscountPCT + '%';
            }
            else if (feeDiscount.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Money) {
                return '$' + feeDiscount.DiscountAmount;
            }
            else {
                return 'No Discount';
            }
        }
        else {
            return 'No Discount';
        }
    }

    isDiscountAvailable(ProviderDoctorId: string, level: number) {
        const feeDiscount = this.feeDiscounts.find(a =>
            a.DiscountName === 'Level' + level
      && a.ProviderDoctorId === ProviderDoctorId
      && a.LOCID === this.LOCID);
        if (feeDiscount && ProviderDoctorId) {
            if (
                (feeDiscount.enumFeeDiscountCalcTypeId === this.enumCoverageTypePercent && feeDiscount.DiscountPCT === 0)
        ||
        (feeDiscount.enumFeeDiscountCalcTypeId === this.enumCoverageTypeAmount && feeDiscount.DiscountAmount === 0)
            ) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }

    saveCurrencyField(event, fieldName, ARTransactionItemID) {
        const inputValue = event.target.value;
        const numberValue = Number(inputValue.replace(/[^0-9.-]+/g, ''));

        this.dataTransactionItems.forEach(item => {
            if (ARTransactionItemID === item.ARTransactionItemID) {
                if (fieldName === 'InsuranceAmount') { item.InsuranceAmount = numberValue; }
                else if (fieldName === 'DeductibleAmount') { item.DeductibleAmount = numberValue; }
                else if (fieldName === 'Price') { item.Price = numberValue; }
                else if (fieldName === 'DoctorsPrice') { item.DoctorsPrice = numberValue; }
                else if (fieldName === 'PriceAdjusted') { item.PriceAdjusted = numberValue; }
                else if (fieldName === 'PatientResponsibility') { item.PatientResponsibility = numberValue; }
            }
        });
    }

    openPostItemsError(errorObject: ARFeeErrors, Message: string, blOverwrite: boolean) {
        const dialogConfig = new MatDialogConfig();

        if (Message && blOverwrite) {
            dialogConfig.data = {
                message: Message,
                errorObj: errorObject
            };
        }
        else {
            dialogConfig.data = {
                message: null,
                errorObj: errorObject
            };
        }
        dialogConfig.panelClass = 'dialog';
        if (this.OtherMissingPost) {
            dialogConfig.data.showCancel = false;
        }
        else {
            dialogConfig.data.showCancel = true;
        }

        const dialogRef = this.dialog.open(ArFeeCalculationErrorComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(async result => {

            if (!result) {
                return;
            }

            // if yes, proceed with posting
            if (result) {
                if (this.toothMissingPost && !this.OtherMissingPost) {
                    // resume post
                    this.postSelectedTransactions(true);
                }
            }
        }, err => {
        });
    }

    openClaimsItemsError(errorObject: ARFeeErrors, Message: string, blOverwrite: boolean) {
        const dialogConfig = new MatDialogConfig();

        if (Message && blOverwrite) {
            dialogConfig.data = {
                message: Message,
                errorObj: errorObject
            };
        }
        else {
            dialogConfig.data = {
                message: null,
                errorObj: errorObject
            };
        }

        dialogConfig.panelClass = 'dialog';
        if (this.OtherMissingPost) {
            dialogConfig.data.showCancel = false;
        }
        else {
            dialogConfig.data.showCancel = true;
        }

        const dialogRef = this.dialog.open(ArFeeCalculationErrorComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(async result => {

            if (!result) {
                return;
            }

            // if yes, proceed with claims
            if (result) {
                if (this.toothMissingPost && !this.OtherMissingPost) {
                    // resume post
                    this.openClaimWizard(true);
                }
            }
        }, err => {
        });

    }

    clearReason(transactionItem: DataARTransactionItemModel, $event: any) {
        if (!$event.checked) {
            transactionItem.enumARNoChargeReasonID = null;
        }
    }

    // not using this currently
    // getInitVariables() {
    //   const promise = new Promise(async (resolve, reject) => {
    //
    //     const patientCaseId = this.globals.currentPatientSelectedCaseItem.PatientCaseId;
    //     const promises: any[] = [
    //       this.getAppointmentInformation(patientCaseId),
    //     ];
    //
    //     try {
    //       const results: any[] = await Promise.all(promises);
    //       const appointment = results[0];
    //       this.DoctorId = appointment.Label_DoctorId;
    //       this.PatientId = appointment.PatientId;
    //       resolve(true);
    //     } catch (err) {
    //       reject(err);
    //     }
    //
    //   });
    //   return promise;
    // }

    // setTransactionDoctorFeeSchedules(dataTransactionItems: DataARTransactionItemModel[]) {
    //
    //   const promise = new Promise<DataARTransactionItemModel[]>(async (resolve, reject) => {
    //
    //     const promises = [];
    //     const dataFeeScheduleDoctorList: FeeScheduleDoctorDataModel[] = this.activeFeeSchedule.dataFeeScheduleDoctors;
    //
    //     if (dataFeeScheduleDoctorList.length === 0) {
    //       reject(' dataFeeScheduleDoctorList is empty');
    //     }
    //
    //     dataTransactionItems.forEach(transactionItem => {
    //
    //       let addedFlag: boolean = false;
    //
    //       if (transactionItem.ProviderDoctorId) {
    //
    //         const selectedDataDoctorFeeSchedules: FeeScheduleDoctorDataModel[] = dataFeeScheduleDoctorList.filter(scheduleDoctor => {
    //           return scheduleDoctor.DoctorId === transactionItem.ProviderDoctorId;
    //         });
    //
    //         if (selectedDataDoctorFeeSchedules.length !== 0) {
    //           addedFlag = true;
    //           transactionItem.DATA_DOCTOR_FEE_SCHEDULES = selectedDataDoctorFeeSchedules;
    //         }
    //       }
    //
    //       if (!addedFlag) {
    //         transactionItem.DATA_DOCTOR_FEE_SCHEDULES = dataFeeScheduleDoctorList;
    //       }
    //
    //       if (!transactionItem.DATA_DOCTOR_FEE_SCHEDULES.length) {
    //         transactionItem.DATA_DOCTOR_FEE_SCHEDULES = dataFeeScheduleDoctorList;
    //       }
    //
    //       if (transactionItem.DATA_DOCTOR_FEE_SCHEDULES.length) {
    //         transactionItem.DATA_DOCTOR_FEE_SCHEDULE = transactionItem.DATA_DOCTOR_FEE_SCHEDULES[0];
    //         transactionItem.ProviderDoctorId = transactionItem.DATA_DOCTOR_FEE_SCHEDULE.DoctorId;
    //       }
    //
    //       transactionItem.DATA_DOCTOR_FEE_SCHEDULES = dataFeeScheduleDoctorList;
    //
    //       promises.push(this.calculateCostForItem(transactionItem));
    //
    //     });
    //
    //     try {
    //       const results: DataARTransactionItemModel[] = await Promise.all(promises);
    //       resolve(results);
    //     } catch (err) {
    //       reject(err);
    //     }
    //
    //   });
    //   return promise;
    // }

    // saveDetailForTransaction(transactionItem: DataARTransactionItemModel, key: string) {
    //   transactionItem[key] = false;
    //   this.calculateCostForItem(transactionItem, true, false, true);
    // }

    // updateTransactionItemFeeDetails(transactionItem: DataARTransactionItemModel, discountApplied: boolean) {
    //   if (discountApplied) {
    //     // fee changed, update patient amount
    //     let insuranceAmount = 0;
    //     if (transactionItem.enumFeeCoverageCalcTypeId === this.enumCoverageTypePercent) {
    //       insuranceAmount = transactionItem.PriceAdjusted * (transactionItem.CoveragePCT / 100);
    //     }
    //     else {
    //       insuranceAmount = transactionItem.CoverageAmount;
    //     }
    //     transactionItem.PatientResponsibility = transactionItem.PriceAdjusted - insuranceAmount;
    //   }
    //
    //   // save transaction item
    //   this.saveTransactionItem(transactionItem);
    // }
    onTransactionItemClick(transactionItem: DataARTransactionItemModel) {
        const model = new TdoNoteQueryModel();
        model.parentObjectName = 'dataARTransactionItems';
        model.objectId = transactionItem.ARTransactionItemID;
        model.patientId = this.globals.currentPatientId;
        model.categoryEnumId = NoteCategoryEnum.Fee;
        model.typeEnumId = NoteTypeEnum.Patient;
        this.notesService.changeNoteQuery(model);
    }

    // updateTransactionItemDoctorList(transactionItem: DataARTransactionItemModel) {
    //   transactionItem.doctorListDropdown = this.doctorsByTDOCID.filter(a => a.LOCID === transactionItem.LOCID);
    // }

    getCaseWorkItemTeeth(caseWorkItemId: string) {
        return this.caseService.getCaseWorkItemTeeth(caseWorkItemId).toPromise();
    }

    getCaseWorkItemDoctor(caseWorkItemId: string) {
        return this.caseService.getCaseWorkItemDoctor(caseWorkItemId).toPromise();
    }

    loadCreateFeeIfToothExists(caseWorkItemId: string) {
        this.getCaseWorkItemTeeth(caseWorkItemId).then(
            (teeth) => {
                if (teeth.length >= 1) {
                    // load fee creation
                    const dialogRef = this.dialog.open(ArCreateTransactionComponent, {
                        // width: '800px',
                        // height: '650px',
                        panelClass: 'dialog',
                        data: {
                            PatientId: this.PatientId,
                            PatientCaseId: this.PatientCaseId,
                            DoctorId: this.activeDoctorFeeSchedule.DoctorId,
                            feeScheduleID: this.activeDoctorFeeSchedule.FeeScheduleID,
                            isCreate: true,
                            TransactionDate: new Date(),
                            OrganizationID: this.activeOrganization.OrganizationID,
                            PatientInsuranceID: this.activeOrganization.PatientInsuranceID,
                            InsuranceID: this.activeOrganization.InsuranceID,
                            DocFeeScheduleID: this.activeDoctorFeeSchedule.DocFeeScheduleID
                        }
                    });
                    dialogRef.afterClosed().subscribe(result => {
                        if (result) {
                            this.loadPatientTransactionItems();
                        }
                    }, err => {
                    });
                }
                else {
                    // show message
                    this.createMessage('The selected Case/Procedure does not have a tooth assigned to it. Please assign a tooth to the selected Case/Procedure in Case View in order to create a fee for the patient.', 'Warning');
                }
            }, err => {
                // if we get here it is because there is no doctor assigned to case work item
                // show message
                this.createMessage('The selected case/procedure does not have a tooth and a doctor assigned to it. Please assign a tooth and a doctor to the selected case/Procedure in Case View in order to create a fee for the patient.', 'Warning');
            }
        );
    }

    async loadCreateFeeIfRequirementsMet(caseWorkItemId: string) {

        const promises: any[] = [
            this.getCaseWorkItemTeeth(caseWorkItemId),
            this.getCaseWorkItemDoctor(caseWorkItemId)
        ];

        try {
            const results: any[] = await Promise.all(promises);
            const teeth: DataPatientCaseWorkItemToothModel[] = results[0];
            const doctor: number = results[1];
            if (teeth.length > 0 && doctor > 0) {
                // passed requirements test for adding fees
                // load fee creation
                const dialogRef = this.dialog.open(ArCreateTransactionComponent, {
                    // width: '800px',
                    // height: '650px',
                    panelClass: 'dialog',
                    data: {
                        PatientId: this.PatientId,
                        PatientCaseId: this.PatientCaseId,
                        DoctorId: this.activeDoctorFeeSchedule.DoctorId,
                        feeScheduleID: this.activeDoctorFeeSchedule.FeeScheduleID,
                        isCreate: true,
                        TransactionDate: new Date(),
                        OrganizationID: this.activeOrganization.OrganizationID,
                        PatientInsuranceID: this.activeOrganization.PatientInsuranceID,
                        InsuranceID: this.activeOrganization.InsuranceID,
                        DocFeeScheduleID: this.activeDoctorFeeSchedule.DocFeeScheduleID
                    }
                });
                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        this.loadPatientTransactionItems();
                    }
                }, err => {
                });
            }
            else {
                // failed requirements test for adding fees
                this.createMessage('The selected case/procedure does not have a tooth and a doctor assigned to it. Please assign a tooth and a doctor to the selected case/Procedure in Case View in order to create a fee for the patient.', 'Warning');
            }
        } catch (err) {
            console.log(err);
            this.createMessage('There was an error checking for procedure requirements', 'Error');
        }
    }

    showPostedChange(showPosted: boolean) {
        this.showPostedTransactions = showPosted;
    }

    onPostedTransactionSelected(event: TdoTableSelectionEvent) {
        this.resetNotesFilter(event.isSelected ? event.model.ARTransactionItemID : '');
    }

    arFeeSelected(event: TdoTableSelectionEvent) {
        this.resetNotesFilter(event.isSelected ? event.model.ARTransactionItemID : '');
    }

    ngOnDestroy(): void {
        for (const sub of this.subscriptions) {
            if (sub)
            {sub.unsubscribe(); }
        }
    }
}

